var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thank"},[_c('div',{staticClass:"thank-img"},[_c('img',{attrs:{"src":"https://imgcdn.chuxingyouhui.com/blackunique/upload/5f4608089254d0a6ae4e34c083261865.png"}})])])
}]

export { render, staticRenderFns }